export default __webpack_public_path__ + "static/media/xiao-genshin.ed735eb8.jfif";